/**
 * Native HTML time input wrapped with PrimeReact styling, exposing an onChange prop
 * that receives `{ value }` matching other HiVolution form inputs.
 *
 * @component
 * @param {Object} props
 * @param {Boolean} [props.required] - Whether the input is required.
 * @param {Boolean} [props.disabled] - Whether the input is disabled.
 * @param {String} [props.value] - Current time value.
 * @param {String} [props.min] - Minimum selectable time.
 * @param {String} [props.max] - Maximum selectable time.
 * @param {Function} props.onChange - Called with `{ value }` when the time changes.
 * @returns {React.JSX.Element}
 */
export default function TimeInput(props) {
  /**
   * Forwards the native input's change event to `props.onChange` as `{ value }`.
   *
   * @param {Event} e - Native change event from the input.
   * @returns {void}
   */
  const onChange = e => {
    props.onChange({ value: e.target.value })
  }
  return (
    <input
      required={props.required}
      disabled={props.disabled}
      className="p-inputtext p-component"
      type="time"
      value={props.value}
      onChange={onChange}
      min={props.min}
      max={props.max}
      onFocus={e => e.target.showPicker()}
    />
  )
}

TimeInput.displayName = 'TimeInput'
